/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { RouterModule, Routes } from '@angular/router';

import { CanActivateService } from './../core/services/can-activate.service';
import { CanDeactivateViaEditGuardService } from './../core/services/can-deactivate-via-edit-guard.service';
import { LmsTerminalComponent } from './terminal.component';
import { LmsTerminalHandlingComponent } from './handling/terminal-handling.component';
import { LmsTerminalNotesComponent } from './notes/terminal-notes.component';
import { LmsTerminalStatusComponent } from './status/terminal-status.component';
import { NgModule } from '@angular/core';
import { TerminalHandlingResolver } from './shared/terminal-handling.resolver';
import { TerminalNotesResolver } from './shared/terminal-notes.resolver';
import { TerminalStatusResolver } from './shared/terminal-status.resolver';

const terminalRoutes: Routes = [
    {
        path: 'terminal',
        component: LmsTerminalComponent,
        data: { tab: 'Terminal' },
        children: [
            {
                path: 'status',
                component: LmsTerminalStatusComponent,
                data: { tab: 'Terminal' },
                resolve: {
                    tabData: TerminalStatusResolver
                },
                canActivate: [CanActivateService],
                canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'status/:tabid',
                component: LmsTerminalStatusComponent,
                data: { tab: 'Terminal' },
                resolve: {
                    tabData: TerminalStatusResolver
                },

                canActivate: [CanActivateService],
                canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'status/:tabid/:search',
                component: LmsTerminalStatusComponent,
                data: { tab: 'Terminal' },
                resolve: {
                    tabData: TerminalStatusResolver
                },

                canActivate: [CanActivateService],
                canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'handling',
                component: LmsTerminalHandlingComponent,
                data: { tab: 'Terminal' },
                resolve: {
                    tabData: TerminalHandlingResolver
                },
                canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'handling/:tabid',
                component: LmsTerminalHandlingComponent,
                data: { tab: 'Terminal' },
                resolve: {
                    tabData: TerminalHandlingResolver
                },
                canActivate: [CanActivateService],
                canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'handling/:tabid/:search',
                component: LmsTerminalHandlingComponent,
                data: { tab: 'Terminal' },
                resolve: {
                    tabData: TerminalHandlingResolver
                },
                canActivate: [CanActivateService],
                canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'notes',
                component: LmsTerminalNotesComponent,
                data: { tab: 'Terminal' },
                resolve: {
                    tabData: TerminalNotesResolver
                },
                canDeactivate: [CanDeactivateViaEditGuardService]
            },
            {
                path: 'notes/:tabid',
                component: LmsTerminalNotesComponent,
                data: { tab: 'Terminal' },
                resolve: {
                    tabData: TerminalNotesResolver
                },
                canActivate: [CanActivateService],
                canDeactivate: [CanDeactivateViaEditGuardService]
            }
        ]
    }
];

/**
 * @export
 * @class TerminalRoutingModule
 */
@NgModule({
    imports: [
        RouterModule.forChild(terminalRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class TerminalRoutingModule {

}
